import NavigationMenuItem from '@/models/Auth/NavigationMenuItem';

export default class NavigationMenu {
    homeMenuItems: NavigationMenuItem[] = [];
    accountsMenuItems: NavigationMenuItem[] = [];
    customerMenuItems: NavigationMenuItem[] = [];
    productsMenuItems: NavigationMenuItem[] = [];
    accountingMenuItems: NavigationMenuItem[] = [];
    reportingMenuItems: NavigationMenuItem[] = [];
    settingsMenuItems: NavigationMenuItem[] = [];
    documentationMenuItems: NavigationMenuItem[] = [];
}